/* eslint-disable no-nested-ternary */
import Moment from 'react-moment';
import { Box, Divider, Group, Stack, Text } from '@mantine/core';
import { IconPaperclip } from '@tabler/icons';
import { MessageS } from '../../Service/MessageS';
import Dot from '../../Atoms/Dot';
import MessagePlaceholderText from '../../Atoms/MessagePlaceholderText';
import { ThemeText } from '../../Atoms/ThemeText';
import MessageOwnerInfo from './MessageOwnerInfo';
import { useParams } from 'react-router-dom';

const EmailHistoryListItem = ({ email, onClick, active }) => {
  const { box } = useParams();
  const unread = box === 'inbox' && email.localDateTime && !email.readTimestamp && !email.sendByUser;

  let contact = email.sendByUser ? (email.to && email.to.length > 0 ? email.to[0] : {}) : email.from;
  if (!contact) contact = {};

  return (
    <>
      <Stack
        p="xs"
        spacing={3}
        onClick={onClick}
        sx={(theme) => ({
          height: 80,
          borderRadius: 10,
          cursor: 'pointer',
          backgroundColor: active
            ? `${theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.secondaryBlue[0]} `
            : 'none',
        })}
      >
        <Box pos="relative">
          <Group spacing="xs">
            {unread && <Dot withoutShadow size={8} colour="#4A90E2" />}
            <ThemeText
              className="overflow-ellipsis"
              weight="bold"
              sx={(theme) => ({
                width: '75%',
                color: theme.colorScheme === 'dark' ? 'white' : 'black',
              })}
            >
              {contact.personDescription ? contact.personDescription : contact.email}
            </ThemeText>
          </Group>
          <Box pos="absolute" right={0} top={0}>
            {email.imap && (
              <ThemeText size={10}>
                {email.localDateTime && <Moment calendar={MessageS.calendarStrings}>{email.localDateTime}</Moment>}
                {!email.localDateTime && <Moment calendar={MessageS.calendarStrings}>{email.lastModified}</Moment>}
              </ThemeText>
            )}
            {!email.imap && (
              <>
                {!email.scheduledTime && (
                  <ThemeText size={10} align="right">
                    {email.localDateTime && <Moment calendar={MessageS.calendarStrings}>{email.localDateTime}</Moment>}
                    {!email.localDateTime && <Moment calendar={MessageS.calendarStrings}>{email.lastModified}</Moment>}
                  </ThemeText>
                )}
                {email.scheduledTime && (
                  <ThemeText size="xs" align="right">
                    <Moment fromNow calendar={MessageS.calendarStrings}>
                      {email.scheduledTime}
                    </Moment>
                  </ThemeText>
                )}
              </>
            )}
          </Box>
        </Box>
        <Box pos="relative">
          {email.subject && (
            <Text
              className="overflow-ellipsis"
              sx={(theme) => ({ width: '90%', color: theme.colorScheme === 'dark' ? 'white' : 'black' })}
            >
              {email.imap && (
                <Text size="xs" lineClamp={1}>
                  {' '}
                  {email.subject}
                </Text>
              )}
              {!email.imap && <MessagePlaceholderText email={email} value={email.subject} />}
            </Text>
          )}
          {!email.subject && (
            <Text italic color="dimmed" weight="bolder">
              Kein Betreff
            </Text>
          )}
          {((email.attachments && email.attachments.length > 0) || email.countOfAttachments > 0) && (
            <Box pos="absolute" right={0} top={-5}>
              <IconPaperclip size={12} color="gray" />
            </Box>
          )}
        </Box>
        <MessageOwnerInfo message={email} />
      </Stack>
      <Divider ml="xs" mr="xs" sx={(theme) => ({ color: theme.colorScheme === 'dark' ? '#212529' : '#E2E2E2' })} />
    </>
  );
};

export default EmailHistoryListItem;
